import script from "./ChatMessageEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessageEditModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessageEditModal.vue?vue&type=style&index=0&id=438296f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-438296f2"]])

export default __exports__